module.exports = __webpack_public_path__ + "img/IMG_9711.7491fcdc.jpg";